.collaboratorsTitle {
  margin-top: 16px;
}
